import React from 'react';
import * as PropTypes from 'prop-types';

const BoutonJeDonneMonAvis = ({ lienBouttonJeDonneMonAvis, width }) => {
    return (
        <a href={lienBouttonJeDonneMonAvis} rel="noopener noreferrer" target="_blank">
            <img
                width={width}
                src="https://voxusagers.numerique.gouv.fr/static/bouton-blanc.svg"
                alt="Je donne mon avis"
                title="Je donne mon avis sur cette démarche"
            />
        </a>
    );
};

BoutonJeDonneMonAvis.propTypes = {
    lienBouttonJeDonneMonAvis: PropTypes.string.isRequired,
    width: PropTypes.string,
};

BoutonJeDonneMonAvis.defaultProps = { width: 'auto' };

export default BoutonJeDonneMonAvis;
